export { default } from './ProductHero';
export * from './ProductHero';
